import { Stack, Alert, Button, Typography } from "@mui/material";
import useSections from "../Hooks/useSections"
import DownloadIcon from '@mui/icons-material/DownloadForOffline';
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import API from "../../../services/API";
import useCourse from "../Hooks/useCourse"
import { useMemo } from "react";
import LockIcon from '@mui/icons-material/Lock';
import { txt } from "../../../services/translation";

export default function Docs(){

    const sections = useSections();
    const course = useCourse();

    const [loading, setLoading] = useState(false)

    const downloadSectionFile = s => {

        API.download(`/study/sections/${s.id}/doc${s.type?.extension}`)
            .then(r => setLoading(false))
            .catch(e => console.log(e))

        return setLoading(s.id)
    }

    const docs = useMemo(() => course.enrollment?.docs || [], [course])

    const docSections = useMemo(() => 
        sections.filter(s => ['pdf','download'].includes(s.type?.id)) || [], 
    [sections]);

    return <Stack spacing={3}>

        <Typography variant='h4'>{txt('administrativeDocuments')}</Typography>

        <Stack sx={{borderTop: 'solid 1px lightgrey'}}>
            {docs.map(d =>
                <Doc 
                    data={d}
                    key={d.id}
                />
            )}
        </Stack>

        {!docs.length && 
            <Alert severity='info' sx={{mt: 1}}>{txt('noDocumentsToShow')}</Alert>
        }

        <Typography variant='h4'>{txt('pdfAndAttachmentsTitle')}</Typography>
        


        <Stack sx={{borderTop: 'solid 1px lightgrey'}}>
            {docSections.map(s => 
                <Row 
                    title={s.title + s.type?.extension}
                    onClick={() => downloadSectionFile(s)}
                    loading={loading === s.id}
                    key={s.id}
                />
            )}
        </Stack>

        {!docSections.length && 
            <Alert severity='info' sx={{mt: 1}}>{txt('noDocumentsToShow')}</Alert>
        }

    </Stack>
}


function Row({title, onClick, loading}){

    return <>
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{borderBottom: 'solid 1px lightgrey'}}>
            
            <p>{title}</p>

            <LoadingButton 
                onClick={onClick} 
                loading={loading}
                size='large'
            >
                <DownloadIcon />
            </LoadingButton>

        </Stack>

    </>

}

function Doc({data}){

    return <>
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{borderBottom: 'solid 1px lightgrey'}}>
            
            <p>
                {data.title} {data.locked && 
                <small style={{color: 'grey', marginLeft: 10}}>
                    {data.lockMessage || "Débloqué en fin de formation (au moins 48h après l'inscription)."}
                </small>}
            </p>

            <Button
                disabled={data.locked ? true : false}
                href={data.url}
                target='_blank'
                rel='noopener noreferrer'
                size='large'
            >
                {data.locked ? <LockIcon /> : <DownloadIcon />}
            </Button>

        </Stack>
    </>
}
